import React, { useContext, useEffect, useState } from "react";
import "../styles/Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { InstallPromptContext } from "../utils/InstallPromptContext";
import config from "../config/config.json";
import { validateToken } from "../pages/ValidateToken";
import axios from "axios";
const logo = "/img/UTDT_Logo.png";
const bodex = "/img/bodexLogo (1).png";
const kpi = "/img/KPI-DASH 2.png";

const Footer = () => {
  const { deferredPrompt, isInstallable, setIsInstallable } =
    useContext(InstallPromptContext);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [validToken, setValidToken] = useState(null);
  useEffect(() => {
    axios
      .get("https://utsb.utahdata.org/bdxbackend/auth/me", {
        withCredentials: true,
      })
      .then(({ data }) => {
        if (data.authenticated) {
          setValidToken(true);
          setUser(data.user);
          localStorage.setItem("user", data.user.name);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null));
  }, []);
  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("token");
      console.log("Token from localStorage:", token);

      if (!token) {
        setValidToken(false);
        return;
      }

      const { valid, user } = await validateToken(token);
      console.log("Validation Response:", { valid, user });

      if (!valid) {
        setValidToken(false);
        return;
      }

      setValidToken(true);
    };

    checkToken();
  }, []);
  //  const{user,setUser}=useContext(localStorage.getItem("token")?JSON.parse(localStorage.getItem("user")):null);
  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log("User response to install prompt:", outcome);
      setIsInstallable(false); // Hide button after click
    }
  };

  //   const handleUTSBClick = () => {
  //   // const token = Cookies.get("token");

  //   if (token) {
  //     // user is logged in → go to UTSB
  //     window.location.replace(
  //       process.env.NODE_ENV === "development"
  //         // ? "http://192.168.1.150:5173/"
  //         ?"http://localhost:5173/"
  //         : "https://47g.utahdata.org/"
  //     );
  //   } else {
  //     // go to utahdata login
  //     window.location.replace(
  //       process.env.NODE_ENV === "development"
  //         ? "http://localhost:3001/login"
  //         : "https://utahdata.org/login"
  //     );
  //   }
  // };
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main footer content - left and right sections */}
        <div className="footer-main">
          {/* Left side: Logo and Description */}
          <div className="footer-left">
            <img src={logo} alt="UtahData Logo" className="footer-logo" />
            <p className="footer-description">
              UTahData.org is a one-stop-shop data portal providing accurate,
              and up-to-date information about Utah's economy, communities, and
              key industries and a lot more.
              <br />
              <br />
              <b>Disclaimer:</b> Images on this site may be subject to
              copyright. All rights belong to their respective owners. No
              infringement is intended.
              <Link to="/copyright" className="no-underline">
                <span className="no-underline text-violet-500">
                  {" "}
                  Copyright Disclaimer
                </span>
              </Link>
            </p>
          </div>

          {/* Built by section - positioned between logo and links */}
          <div className="footer-built-by-middle">
            <div className="inline-flex items-center px-2 sm:px-3 py-2 pencil-border rounded-lg shadow-sm bg-white overflow-x-auto">
              <span className="text-[#2b2b2b] text-xs sm:text-sm whitespace-nowrap font-medium leading-none">
                Built by
              </span>
              <a
                href="https://bodex.io/products/utahdata/"
                className="flex items-center"
                target="_blank"
              >
                <img src={bodex} alt="Bodex Logo" className="h-4 sm:h-5 mx-1" />
              </a>
              <span className="text-[#2b2b2b] text-xs sm:text-sm font-medium leading-none">
                using
              </span>
              <a
                href="https://bodex.io/products/kpi-dash/"
                target="_blank"
                className="flex items-center"
              >
                <img
                  src={kpi}
                  alt="KPI Dashboard Logo"
                  className="h-6 sm:h-8 mx-1 rounded-full"
                />
              </a>
              <Link
                to=""
                className="text-[#2b2b2b] text-xs sm:text-sm no-underline font-mono leading-none"
              >
                20250916.v3.198
              </Link>
            </div>
          </div>

          {/* Right side: Quick Links, Mail, Social, Legal */}
          <div className="footer-right">
            {/* Quick Links */}
            <div className="footer-column">
              <h4 className="footer-heading">QUICK LINKS</h4>
              <div className="footer-links">
                <a href="/utah-at-a-glance">Utah At a Glance</a>
                <a href="/verticals">Utah Key Economic Verticals</a>
                <a href="/contact-us">Contact Us</a>
                {user ? (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      // Proactively clear client-side auth state
                      try {
                        localStorage.removeItem("token");
                        localStorage.removeItem("username");
                        localStorage.removeItem("user");
                      } catch {}

                      // call logout API which clears the server cookie/session
                      axios
                        .post(
                          config.APP_URL + "/utahdata/logout",
                          {},
                          { withCredentials: true },
                        )
                        .catch((err) => console.error("Logout error:", err))
                        .finally(() => {
                          setUser(null);
                          setValidToken(false);
                          localStorage.removeItem("username");
                          window.location.href = "https://utahdata.org/login";
                          if (typeof setValidToken === "function") {
                            setValidToken(false);
                          }
                          // Double-check removal before redirect
                          try {
                            localStorage.removeItem("token");
                            localStorage.removeItem("username");
                            localStorage.removeItem("user");
                          } catch {}
                          // window.location.href = "https://utahdata.org/login"; // redirect to main login
                        });
                    }}
                  >
                    {user.name} (Logout)
                  </a>
                ) : (
                  <a href="https://utahdata.org/login">Login</a>
                )}
                {user && (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open("https://utsb.utahdata.org/home", "_blank");
                    }}
                  >
                    UTSB
                  </a>
                )}
                <a href="/founders-note">Founder's Note</a>
                <a href="/sitemap">Site Map</a>
              </div>
            </div>

            {/* Mail and Social */}
            <div className="footer-column">
              <div className="footer-section">
                <h4 className="footer-heading">MAIL</h4>
                <a href="mailto:bodex@bodex.io?subject=Interested%20in%20UtahData.org&body=I'm%20interested%20to%20learn%20more%20about%20UtahData.org.%20Please%20share%20more%20details.">
                  bodex@bodex.io
                </a>
                {/* </div>
              <div className="footer-section"> */}
                <h4 className="footer-heading">SOCIAL</h4>
                <div className="footer-social">
                  <a
                    href="https://www.facebook.com/profile.php?id=61571797313046"
                    target="_blank"
                  >
                    Facebook
                  </a>
                  <span>|</span>
                  <a
                    href="https://www.linkedin.com/company/utahdata/"
                    target="_blank"
                  >
                    Linkedin
                  </a>
                </div>
              </div>
              <div className="footer-links">
                <a
                  href="/privacy-policy"
                  className="hover:underline text-inherit"
                >
                  Privacy Policy
                </a>
                <a href="/faq" className="hover:underline text-inherit">
                  FAQ
                </a>
              </div>
            </div>

            {/* Privacy Policy and FAQ */}
            {/* <div className="footer-column">
              <div className="footer-links">
                <a
                  href="/privacy-policy"
                  className="hover:underline text-inherit"
                >
                  Privacy Policy
                </a>
                <a href="/faq" className="hover:underline text-inherit">
                  FAQ
                </a>
              </div>
            </div> */}
          </div>
        </div>
        {/* Copyright section - below quick links */}
        <div className="footer-copyright-below footer-right">
          <p className="footer-description">
            © Copyright {new Date().getFullYear()} UTahData.org
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
